/**
 * Reusable Glider.js Slider Component
 * Initializes glider sliders with configurable options
 */
; (function () {
  function initGliderSlider(section) {
    if (!section) return;

    var gliderEl = section.querySelector('.glider-slider__grid.glider');
    if (!gliderEl) return;

    var sectionId = gliderEl.id;
    var prevId = sectionId + '-prev';
    var nextId = sectionId + '-next';
    // Get configuration from data attributes
    var slidesToShowMobile = parseFloat(gliderEl.getAttribute('data-slides-mobile')) || 2;
    var slidesToShowTablet = parseFloat(gliderEl.getAttribute('data-slides-tablet')) || 3;
    var slidesToShowDesktop = parseFloat(gliderEl.getAttribute('data-slides-desktop')) || 4;
    var slidesToShowLargeDesktop = parseFloat(gliderEl.getAttribute('data-slides-large-desktop')) || slidesToShowDesktop;
    var slideGap = gliderEl.getAttribute('data-slide-gap') || '1.25rem';

    function gliderOptions(prevEl, nextEl) {
      var arrowsCfg = (prevEl || nextEl)
        ? { prev: prevEl || ('#' + prevId), next: nextEl || ('#' + nextId) }
        : { prev: '#' + prevId, next: '#' + nextId };

      return {
        slidesToShow: slidesToShowMobile,
        slidesToScroll: 1,
        draggable: true,
        dots: false,
        arrows: arrowsCfg,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: slidesToShowTablet,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: slidesToShowDesktop,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: slidesToShowLargeDesktop,
              slidesToScroll: 1
            }
          }
        ]
      };
    }

    function createGlider(el) {
      if (!el) return;
      if (el._gliderInstance) return;

      if (typeof Glider === 'undefined') {
        // Glider not loaded yet, retry
        setTimeout(function () { createGlider(el); }, 100);
        return;
      }

      var tries = 0;
      function attempt() {
        if (el.offsetWidth > 0 || tries >= 6) {
          try {
            var prevEl = document.getElementById(prevId);
            var nextEl = document.getElementById(nextId);
            var opts = gliderOptions(prevEl, nextEl);
            var gl = new Glider(el, opts);
            // Mark arrows container as active to show arrows
            var arrowsContainer = section.querySelector('.glider-slider__arrows');
            if (arrowsContainer) {
              arrowsContainer.classList.add('glider-active');
            }
            el._gliderInstance = gl;
            el.setAttribute('data-glider-init', '1');
          } catch (e) {
            console.warn('Glider init failed:', e);
            tries++;
            if (tries < 6) requestAnimationFrame(attempt);
          }
        } else {
          tries++;
          if (tries < 6) requestAnimationFrame(attempt);
        }
      }
      attempt();
    }

    // Wait a moment for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        createGlider(gliderEl);
      });
    } else {
      setTimeout(function () { createGlider(gliderEl); }, 50);
    }
  }

  // Initialize all glider-slider sections
  function initAll() {
    var sections = document.querySelectorAll('.glider-slider');
    sections.forEach(function (s) {
      initGliderSlider(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Also expose for manual initialization if needed
  window.initGliderSlider = initGliderSlider;
})();
